import React from 'react';
import PropTypes from 'prop-types';
import 'AppSrc/core/style/components/form/form-base-components/sub-components/field-sub-title.css';
// This component is for subtitle of field title like customer impact statement
const FieldSubTitle = React.memo(({
  fieldSubTitle,
  optional,
}) => (
  <p className="field-sub-title">{`${fieldSubTitle}${optional ? ' (optional)' : ''}`}</p>
));

FieldSubTitle.propTypes = {
  fieldSubTitle: PropTypes.string,
  optional: PropTypes.bool,
};

export { FieldSubTitle };
